import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import ErrorBoundary from './ErrorBoundary';

type QueryErrorBoundaryProps = {
  children: ReactNode;
};

const QueryErrorBoundary = ({ children }: QueryErrorBoundaryProps) => {
  const { reset } = useQueryErrorResetBoundary();

  return <ErrorBoundary onReset={reset}>{children}</ErrorBoundary>;
};

export default QueryErrorBoundary;
